module.exports = __webpack_public_path__ + "static/images/car.23LoZbf.svg";